// Emplacement réservé au LOGO MASTER officiel Art Event.
// Le fichier officiel (PNG/SVG) sera fourni par le client et intégré ici.
// En attendant : marque typographique provisoire, aucun logo généré.

export const Logo = ({ dark = false, compact = false }) => (
  <span data-testid="brand-logo" className="inline-flex items-baseline gap-1.5 select-none">
    <span className={`font-heading text-xl tracking-[0.18em] font-semibold ${dark ? "text-cream" : "text-deepgreen"}`}>
      ART EVENT
    </span>
    {!compact && (
      <span className={`text-[10px] uppercase tracking-[0.3em] ${dark ? "text-sage" : "text-muted-foreground"}`}>
        Location &amp; Décoration
      </span>
    )}
  </span>
);
